import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 md:px-10 pt-20 pb-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20editorial%20flat%20lay%20composition%20featuring%20carefully%20arranged%20fashion%20accessories%20including%20a%20woven%20straw%20bag%2C%20gold%20toned%20jewelry%20pieces%2C%20silk%20scarf%20in%20sage%20green%2C%20and%20aviator%20sunglasses%20on%20a%20textured%20oatmeal%20linen%20surface%2C%20warm%20diffused%20morning%20sunlight%20casting%20gentle%20elongated%20shadows%2C%20lifestyle%20photography%20with%20organic%20imperfections%20and%20natural%20texture%20details%2C%20peaceful%20serene%20atmosphere%20with%20muted%20sage%20and%20sand%20color%20palette&width=1600&height=900&seq=kg-hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/30 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-900 leading-tight mb-6">
          {t('hero.title1')}
          <br />
          <span className="text-primary-600 italic">{t('hero.title2')}</span>
          <br />
          <span className="text-2xl md:text-3xl lg:text-4xl font-body font-light text-foreground-600">{t('hero.title3')}</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta_buy')}
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
        <div className="relative bg-background-50 rounded-2xl overflow-hidden -translate-y-4 transition-transform duration-500 hover:scale-[1.02]">
          <div className="aspect-[3/4] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20a%20pair%20of%20premium%20leather%20sandals%20in%20cognac%20brown%20on%20a%20textured%20stone%20surface%2C%20warm%20golden%20hour%20side%20lighting%20creating%20rich%20dimensional%20shadows%2C%20editorial%20fashion%20product%20shot%20with%20refined%20Mediterranean%20aesthetic%2C%20natural%20terracotta%20tones%20and%20organic%20textures&width=600&height=800&seq=kg-hero-card1-v2&orientation=portrait"
              alt="Kakobuy produkt 1"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
        <div className="relative bg-background-50 rounded-2xl overflow-hidden translate-y-2 transition-transform duration-500 hover:scale-[1.02]">
          <div className="aspect-[3/4] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20product%20photography%20of%20a%20premium%20woven%20tote%20bag%20in%20natural%20jute%20fiber%20with%20leather%20handles%2C%20styled%20against%20a%20warm%20sand%20colored%20wall%20backdrop%2C%20soft%20afternoon%20light%20through%20sheer%20curtains%20creating%20gentle%20diffusion%2C%20minimalist%20bohemian%20aesthetic%20with%20organic%20material%20textures%20and%20subtle%20earthy%20warmth&width=600&height=800&seq=kg-hero-card2-v2&orientation=portrait"
              alt="Kakobuy produkt 2"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
        <div className="relative bg-background-50 rounded-2xl overflow-hidden -translate-y-4 transition-transform duration-500 hover:scale-[1.02]">
          <div className="aspect-[3/4] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Sophisticated%20still%20life%20product%20photography%20of%20a%20ceramic%20vase%20with%20dried%20pampas%20grass%20arrangement%20next%20to%20a%20neatly%20folded%20cashmere%20throw%20blanket%20in%20warm%20taupe%2C%20styled%20on%20a%20rustic%20wooden%20console%20table%2C%20soft%20morning%20light%20streaming%20through%20an%20arched%20window%2C%20refined%20contemporary%20interior%20aesthetic%20with%20natural%20tonal%20harmony%20and%20serene%20composition&width=600&height=800&seq=kg-hero-card3-v2&orientation=portrait"
              alt="Kakobuy produkt 3"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}